const LanguageToCountryMap = {
  aa: {language: 'afar', country: 'Eritrea', countryCode: 'er'},
  ab: {language: 'abkhazian', country: 'Georgia', countryCode: 'ge'},
  af: {language: 'afrikaans', country: 'Namibia', countryCode: 'na'},
  am: {language: 'amharic', country: 'Ethiopia', countryCode: 'et'},
  ar: {language: 'arabic', country: 'United Arab Emirates', countryCode: 'ae'},
  as: {language: 'assamese', country: 'India', countryCode: 'in'},
  ay: {language: 'aymara', country: 'Bolivia', countryCode: 'bo'},
  az: {language: 'azerbaijani', country: 'Azerbaijan', countryCode: 'az'},
  ba: {language: 'bashkir', country: 'Russia', countryCode: 'ru'},
  be: {language: 'byelorussian', country: 'Belarus', countryCode: 'by'},
  bg: {language: 'bulgarian', country: 'Bulgaria', countryCode: 'bg'},
  bh: {language: 'bihari', country: 'Nepal', countryCode: 'np'},
  bi: {language: 'bislama', country: 'Vanuatu', countryCode: 'vu'},
  bn: {language: 'bengali, bangla', country: 'India', countryCode: 'in'},
  bo: {language: 'tibetan', country: 'Bhutan', countryCode: 'bt'},
  br: {language: 'breton', country: 'France', countryCode: 'fr'},
  ca: {language: 'catalan', country: 'Spain', countryCode: 'es'},
  co: {language: 'corsican', country: 'France', countryCode: 'fr'},
  cs: {language: 'czech', country: 'Czech Republic', countryCode: 'cz'},
  cy: {language: 'welsh', country: 'United Kingdom', countryCode: 'gb'},
  da: {language: 'danish', country: 'Denmark', countryCode: 'dk'},
  de: {language: 'german', country: 'Germany', countryCode: 'de'},
  dz: {language: 'bhutani', country: 'Bhutan', countryCode: 'bt'},
  el: {language: 'greek', country: 'Greece', countryCode: 'gr'},
  en: {
    language: 'english, american',
    country: 'United Kingdom',
    countryCode: 'gb',
  },
  eo: {language: 'esperanto', country: 'Esperanto', countryCode: ''},
  es: {language: 'spanish', country: 'Spain', countryCode: 'es'},
  et: {language: 'estonian', country: 'Estonia', countryCode: 'ee'},
  eu: {language: 'basque', country: 'Spain', countryCode: 'es'},
  fa: {language: 'persian', country: 'Iran', countryCode: 'ir'},
  fi: {language: 'finnish', country: 'Finland', countryCode: 'fi'},
  fj: {language: 'fiji', country: 'Fiji', countryCode: 'fj'},
  fo: {language: 'faeroese', country: 'Denmark', countryCode: 'dk'},
  fr: {language: 'french', country: 'France', countryCode: 'fr'},
  fy: {language: 'frisian', country: 'Netherlands', countryCode: 'nl'},
  ga: {language: 'irish', country: 'Ireland', countryCode: 'ie'},
  gd: {
    language: 'gaelic ("scots gaelic")',
    country: 'United Kingdom',
    countryCode: 'gb',
  },
  gl: {language: 'galician', country: 'Spain', countryCode: 'es'},
  gn: {language: 'guarani', country: 'Paraguay', countryCode: 'py'},
  gu: {language: 'gujarati', country: 'India', countryCode: 'id'},
  ha: {language: 'hausa', country: 'Niger', countryCode: 'ne'},
  hi: {language: 'hindi', country: 'India', countryCode: 'in'},
  hr: {language: 'croatian', country: 'Croatia', countryCode: 'hr'},
  hu: {language: 'hungarian', country: 'Hungary', countryCode: 'hu'},
  hy: {language: 'armenian', country: 'Armenia', countryCode: 'ar'},
  ia: {language: 'interlingua', country: 'Interlingua', countryCode: ''},
  ie: {language: 'interlingue', country: 'Interlingue', countryCode: ''},
  ik: {language: 'inupiak', country: 'Canada', countryCode: 'ca'},
  in: {language: 'indonesian', country: 'Indonesia', countryCode: 'id'},
  is: {language: 'icelandic', country: 'Iceland', countryCode: 'is'},
  it: {language: 'italian', country: 'Italy', countryCode: 'it'},
  iw: {language: 'hebrew', country: 'Israel', countryCode: 'il'},
  ja: {language: 'japanese', country: 'Japan', countryCode: 'jp'},
  ji: {language: 'yiddish', country: 'Israel', countryCode: 'il'},
  jw: {language: 'javanese', country: 'Indonesia', countryCode: 'id'},
  ka: {language: 'georgian', country: 'Georgia', countryCode: 'ge'},
  kk: {language: 'kazakh', country: 'Kazakhstan', countryCode: 'kz'},
  kl: {language: 'greenlandic', country: 'Denmark', countryCode: 'dk'},
  km: {language: 'cambodian', country: 'Cambodia', countryCode: 'kh'},
  kn: {language: 'kannada', country: 'India', countryCode: 'in'},
  ko: {language: 'korean', country: 'Republic of Korea', countryCode: 'kr'},
  ks: {language: 'kashmiri', country: 'India', countryCode: 'in'},
  ku: {language: 'kurdish', country: 'Iraq', countryCode: 'iq'},
  ky: {language: 'kirghiz', country: 'Kyrgyzstan', countryCode: 'kg'},
  la: {language: 'latin', country: 'Vatican City', countryCode: 'va'},
  ln: {language: 'lingala', country: 'Congo', countryCode: 'cg'},
  lo: {
    language: 'laothian',
    country: "Lao People's Democratic Republic",
    countryCode: 'la',
  },
  lt: {language: 'lithuanian', country: 'Lithuania', countryCode: 'lt'},
  lv: {language: 'latvian, lettish', country: 'Latvia', countryCode: 'lv'},
  mg: {language: 'malagasy', country: 'Madagascar', countryCode: 'mg'},
  mi: {language: 'maori', country: 'New Zealand', countryCode: 'nz'},
  mk: {language: 'macedonian', country: 'Macedonia', countryCode: 'mk'},
  ml: {language: 'malayalam', country: 'Malaysia', countryCode: 'my'},
  mn: {language: 'mongolian', country: 'Mongolia', countryCode: 'mn'},
  mo: {language: 'moldavian', country: 'Moldova', countryCode: 'md'},
  mr: {language: 'marathi', country: 'India', countryCode: 'in'},
  ms: {language: 'malay', country: 'Malaysia', countryCode: 'my'},
  mt: {language: 'maltese', country: 'Malta', countryCode: 'mt'},
  my: {language: 'burmese', country: 'Myanmar', countryCode: 'mm'},
  na: {language: 'nauru', country: 'Nauru', countryCode: 'nr'},
  ne: {language: 'nepali', country: 'Nepal', countryCode: 'np'},
  nl: {language: 'dutch', country: 'Netherlands', countryCode: 'nl'},
  no: {language: 'norwegian', country: 'Norway', countryCode: 'no'},
  oc: {language: 'occitan', country: 'France', countryCode: 'fr'},
  om: {language: 'oromo, afan', country: 'Ethiopia', countryCode: 'et'},
  or: {language: 'oriya', country: 'India', countryCode: 'in'},
  pa: {language: 'punjabi', country: 'Pakistan', countryCode: 'pk'},
  pl: {language: 'polish', country: 'Poland', countryCode: 'pl'},
  ps: {language: 'pashto, pushto', country: 'Afghanistan', countryCode: 'af'},
  pt: {
    language: 'portuguese',
    country: 'Portuguese Republic',
    countryCode: 'pt',
  },
  qu: {language: 'quechua', country: 'Bolivia', countryCode: 'bo'},
  rm: {language: 'rhaeto-romance', country: 'Italy', countryCode: 'it'},
  rn: {language: 'kirundi', country: 'Burundi', countryCode: 'bi'},
  ro: {language: 'romanian', country: 'Romania', countryCode: 'ro'},
  ru: {language: 'russian', country: 'Russia', countryCode: 'ru'},
  rw: {language: 'kinyarwanda', country: 'Rwanda', countryCode: 'rw'},
  sa: {language: 'sanskrit', country: 'India', countryCode: 'in'},
  sd: {language: 'sindhi', country: 'Pakistan', countryCode: 'pk'},
  sg: {language: 'sangro', country: 'Italy', countryCode: 'it'},
  sh: {
    language: 'serbo-croatian',
    country: 'Republic of Serbia',
    countryCode: 'rs',
  },
  si: {language: 'singhalese', country: 'Sri Lanka', countryCode: 'lk'},
  sk: {language: 'slovak', country: 'Slovakia', countryCode: 'sk'},
  sl: {language: 'slovenian', country: 'Slovenia', countryCode: 'si'},
  sm: {language: 'samoan', country: 'Samoa', countryCode: 'ws'},
  sn: {language: 'shona', country: 'Zimbabwe', countryCode: 'zw'},
  so: {language: 'somali', country: 'Somalia', countryCode: 'so'},
  sq: {language: 'albanian', country: 'Albania', countryCode: 'al'},
  sr: {language: 'serbian', country: 'Republic of Serbia', countryCode: 'rs'},
  ss: {language: 'siswati', country: 'Swaziland', countryCode: 'sz'},
  st: {language: 'sesotho', country: 'Lesotho', countryCode: 'ls'},
  su: {language: 'sudanese', country: 'Sudan', countryCode: 'sd'},
  sv: {language: 'swedish', country: 'Sweden', countryCode: 'se'},
  sw: {language: 'swahili', country: 'Kenya', countryCode: 'ke'},
  ta: {language: 'tamil', country: 'Sri Lanka', countryCode: 'lk'},
  te: {language: 'tegulu', country: 'India', countryCode: 'in'},
  tg: {language: 'tajik', country: 'Tajikistan', countryCode: 'tj'},
  th: {language: 'thai', country: 'Thailand', countryCode: 'th'},
  ti: {language: 'tigrinya', country: 'Eritrea', countryCode: 'er'},
  tk: {language: 'turkmen', country: 'Turkmenistan', countryCode: 'tm'},
  tl: {language: 'tagalog', country: 'Philippines', countryCode: 'ph'},
  tn: {language: 'setswana', country: 'Botswana', countryCode: 'bw'},
  to: {language: 'tonga', country: 'Tonga', countryCode: 'to'},
  tr: {language: 'turkish', country: 'Turkey', countryCode: 'tr'},
  ts: {language: 'tsonga', country: 'South Africa', countryCode: 'za'},
  tt: {language: 'tatar', country: 'Mongolia', countryCode: 'mn'},
  tw: {language: 'twi', country: 'Australia', countryCode: 'au'},
  uk: {language: 'ukrainian', country: 'Ukraine', countryCode: 'ua'},
  ur: {language: 'urdu', country: 'Pakistan', countryCode: 'pk'},
  uz: {language: 'uzbek', country: 'Uzbekistan', countryCode: 'uz'},
  vi: {language: 'vietnamese', country: 'Vietnam', countryCode: 'vn'},
  vo: {language: 'volapuk', country: 'Volapuk', countryCode: ''},
  wo: {language: 'wolof', country: 'Senegal', countryCode: 'sn'},
  xh: {language: 'xhosa', country: 'South Africa', countryCode: 'za'},
  yo: {language: 'yoruba', country: 'Nigeria', countryCode: 'ng'},
  zh: {language: 'chinese', country: 'China', countryCode: 'cn'},
  zu: {language: 'zulu', country: 'South Africa', countryCode: 'za'},
} as const;

export default LanguageToCountryMap;
